import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "left-filter-section" };
const _hoisted_2 = { class: "right-filter-section" };
import { ref, watch, onMounted, computed, } from 'vue';
import { searchFieldOptionList, userStatusOptionList, } from '@/constants/userManagement';
import SearchInput from '@/components/Form/SearchInput.vue';
import Select from '@/components/Form/Select.vue';
import SubControllerTemplate from '@/templates/SubControllerTemplate.vue';
import SearchInputWrapper from '@/components/Form/SearchInputWrapper.vue';
import { useRoute, useRouter, } from 'vue-router';
import { getGlobalStore } from '@/lib/global-store';
import { pageSizeEnum } from '@/constants/pageSizeOptionList';
const lc = 'views.user_management.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubController',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const vuexStore = getGlobalStore();
        const isInitialize = ref(false);
        const userStatusType = ref('');
        const userLevel = ref('');
        const pageSizeType = ref('20');
        const searchFieldType = ref('');
        const searchValue = ref('');
        const filterOption = computed(() => vuexStore.state.userManagement.userList.filterOption);
        const sortOption = computed(() => vuexStore.state.userManagement.userList.sortOption);
        const getterSubscribeHubId = computed(() => vuexStore.getters['hubSelector/getterSubscribeHubId']);
        const getterSearchValue = computed(() => vuexStore.getters['userManagement/userList/getterSearchValue']);
        const getterUserLevelList = computed(() => vuexStore.getters['userManagement/userList/getterUserLevelList']);
        const setFilterOption = (payload) => vuexStore.dispatch('userManagement/userList/setFilterOption', payload);
        const getUserList = () => vuexStore.dispatch('userManagement/userList/getUserList');
        const setFilterOptionsValue = (isReset = false) => {
            searchFieldType.value = searchFieldOptionList[0].value;
            searchValue.value = '';
            const [, secondOption,] = userStatusOptionList;
            userStatusType.value = secondOption.value;
            userLevel.value = getterUserLevelList.value[0].value;
            pageSizeType.value = pageSizeEnum['50'];
            if (isReset) {
                return;
            }
            const { searchField: searchFieldQuery, searchValue: searchValueQuery, userStatusType: userStatusTypeQuery, userLevel: userLevelQuery, pageSizeType: pageSizeTypeQuery, } = route.query;
            if (searchFieldQuery) {
                searchFieldType.value = searchFieldQuery;
                searchValue.value = searchValueQuery;
                userStatusType.value = userStatusTypeQuery;
                userLevel.value = userLevelQuery;
                pageSizeType.value = pageSizeTypeQuery;
            }
        };
        const initPage = async () => {
            if (isInitialize.value) {
                router.replace({
                    query: {
                        userStatusType: userStatusType.value,
                        userLevel: userLevel.value,
                        pageSizeType: pageSizeType.value,
                        searchField: searchFieldType.value,
                        searchValue: searchValue.value,
                    },
                }).catch(() => { });
            }
            await setFilterOption({
                userStatusType: userStatusType.value,
                userLevel: userLevel.value,
                pageSizeType: pageSizeType.value,
                searchWord: {
                    field: searchFieldType.value,
                    value: searchValue.value,
                },
            });
            if (!getterSubscribeHubId.value) {
                isInitialize.value = false;
                return;
            }
            getUserList();
            isInitialize.value = false;
        };
        const setInitializePage = (isReset = false) => {
            isInitialize.value = true;
            setFilterOptionsValue(isReset);
            initPage();
        };
        onMounted(() => {
            setInitializePage();
        });
        /**
         * 검색유형 핸들러
         */
        const handleChangeSearchFieldType = (selectedType) => {
            searchFieldType.value = selectedType;
        };
        /**
         * 검색 핸들러
         */
        const handleSearch = async (value) => {
            await setFilterOption({
                searchWord: {
                    field: searchFieldType.value,
                    value,
                },
            });
            const { query } = route;
            router.replace({
                query: {
                    ...query,
                    searchField: searchFieldType.value,
                    searchValue: value,
                },
            }).catch(() => { });
        };
        /**
         * 셀렉터 변경 핸들러
         */
        const handleChangeSelect = (selectType) => (selectOptionValue) => {
            if (!selectOptionValue) {
                return;
            }
            const { query } = route;
            const replaceParam = {
                query: {
                    ...query,
                    [selectType]: selectOptionValue,
                },
            };
            router.replace(replaceParam);
            // setFilterOption({
            //   [selectType]: selectOptionValue,
            // });
            const filterData = {
                [selectType]: selectOptionValue,
            };
            if (selectType === 'pageSizeType') {
                filterData.pageNumber = '1';
            }
            setFilterOption(filterData);
        };
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const handleClickResetButton = () => {
            setInitializePage(true);
        };
        watch(() => filterOption.value, () => {
            if (!getterSubscribeHubId.value) {
                return;
            }
            if (!isInitialize.value) {
                getUserList();
            }
        }, {
            deep: true,
        });
        watch(() => sortOption.value, () => {
            if (!getterSubscribeHubId.value) {
                return;
            }
            if (!isInitialize.value) {
                getUserList();
            }
        }, {
            deep: true,
        });
        watch(() => getterSubscribeHubId.value, () => {
            if (!isInitialize.value) {
                const firstPageNumber = 1;
                setFilterOption({
                    pageNumber: firstPageNumber,
                });
                getUserList();
            }
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createBlock(SubControllerTemplate, null, {
                toolsSlot: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createCommentVNode(" 상태 "),
                        _createVNode(Select, {
                            width: 100,
                            value: filterOption.value.userStatusType,
                            title: _ctx.$t(`${lc}status`),
                            items: _unref(userStatusOptionList),
                            "on-change": handleChangeSelect('userStatusType')
                        }, null, 8 /* PROPS */, ["value", "title", "items", "on-change"]),
                        _createCommentVNode(" 사용자 레벨"),
                        _createVNode(Select, {
                            title: _ctx.$t(`${lc}user_level`),
                            value: filterOption.value.userLevel,
                            items: getterUserLevelList.value,
                            "on-change": handleChangeSelect('userLevel')
                        }, null, 8 /* PROPS */, ["title", "value", "items", "on-change"]),
                        _createCommentVNode(" 초기화 버튼 "),
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickResetButton }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { size: "16" }, {
                                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                                        _createTextVNode(" mdi-restart ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [0]
                                }),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.reset')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    "size-l": true,
                                    outlined: true
                                }
                            ]
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(SearchInputWrapper, null, {
                            default: _withCtx(() => [
                                _createVNode(Select, {
                                    value: searchFieldType.value,
                                    items: _unref(searchFieldOptionList),
                                    "on-change": handleChangeSearchFieldType
                                }, null, 8 /* PROPS */, ["value", "items"]),
                                _createVNode(SearchInput, {
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: _ctx.$t(`common.search_word`) }),
                                    "on-search": handleSearch,
                                    "default-value": getterSearchValue.value
                                }, null, 8 /* PROPS */, ["placeholder", "default-value"])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
